"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importDefault(require("react"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const AssetsOffer_1 = __importDefault(require("./AssetsOffer"));
const AssetsOfferPage = () => react_1.default.createElement(AssetsOffer_1.default, null);
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.OFFER_READ })(AssetsOfferPage));
